import t from "./_baseAssignValue.js";
import i from "./eq.js";
var s = Object.prototype, p = s.hasOwnProperty;
function l(r, a, o) {
  var n = r[a];
  (!(p.call(r, a) && i(n, o)) || o === void 0 && !(a in r)) && t(r, a, o);
}
export {
  l as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_assignValue.js
// module id = 903
// module chunks = 67